import type { Nullable } from "@iot-platform/core";
import { ToastManagerRepository } from "@iot-platform/core";
import type { UserResume } from "@user/domain/models/user.model";
import type { UserRepository } from "@user/domain/repositories/user.repository";
import { userTypes } from "@user/root/user-types.di";
import { inject, injectable } from "inversify";

@injectable()
export class UserGetByEmailUseCase {
    constructor(
        @inject(userTypes.repositories.UserRepository)
        private readonly userRepository: UserRepository,
    ) {}

    /**
     * Resolves an email address to an existing user. Returns `null` when no
     * user matches the given email. The email is normalized (trimmed and
     * lowercased) so different casing or extra whitespace still match.
     */
    async execute(email: string): Promise<Nullable<UserResume>> {
        const normalizedEmail = email.trim().toLowerCase();

        const userResult =
            await this.userRepository.getByEmail(normalizedEmail);

        if (userResult.isErr()) {
            const error = userResult.error.message;

            ToastManagerRepository.error(error);

            return null;
        }

        return userResult.value;
    }
}
